import React, { useState, useEffect } from "react";
import "./FilterPrototype.css";
import { firestore } from "./firebase";
import { collection, getDocs } from "firebase/firestore";

// Use exact Firestore keys
const filterKeys = ["region", "subRegion", "country", "ethnicGroup", "curator"];

const FilterPrototype = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    const fetchFilterOptions = async () => {
      const snap = await getDocs(collection(firestore, "uploads"));
      const docs = snap.docs.map(doc => doc.data());

      const values = {
        region: new Set(),
        subRegion: new Set(),
        country: new Set(),
        ethnicGroup: new Set(),
        curator: new Set()
      };

      docs.forEach((doc) => {
        filterKeys.forEach((key) => {
          const value = doc[key];
          if (value && typeof value === "string" && value.trim()) {
            values[key].add(value.trim());
          }
        });
      });

      const cleaned = {};
      filterKeys.forEach((key) => {
        cleaned[key] = Array.from(values[key]).sort();
      });

      console.log("✅ Loaded filter values:", cleaned);
      setFilterOptions(cleaned);
    };

    fetchFilterOptions();
  }, []);

  const toggle = (key, value) => {
    setSelectedFilters((prev) => {
      const list = prev[key] || [];
      const updated = list.includes(value)
        ? list.filter((v) => v !== value)
        : [...list, value];
      return { ...prev, [key]: updated };
    });
  };

  const renderPills = (key) => {
    const items = filterOptions[key] || [];
    const selected = selectedFilters[key] || [];

    if (!items.length) return null;

    return (
      <div className="filter-pills">
        {items.map((item) => (
          <button
            key={item}
            className={`pill ${selected.includes(item) ? "selected" : ""}`}
            onClick={() => toggle(key, item)}
          >
            {item}
          </button>
        ))}
      </div>
    );
  };

  const getLabel = (key) => {
    switch (key) {
      case "subRegion": return "Subregion";
      case "ethnicGroup": return "Ethnic Group";
      case "curator": return "Contributor";
      default: return key.charAt(0).toUpperCase() + key.slice(1);
    }
  };

  return (
    <>
      <div className="filter-content-above">
        {renderPills(activeTab)}
      </div>

      <div className="filter-prototype-fixed">
        <div className="filter-tab-row">
          {filterKeys.map((key) => (
            <button
              key={key}
              className={`filter-tab ${activeTab === key ? "active" : ""}`}
              onClick={() => setActiveTab(activeTab === key ? null : key)}
            >
              {getLabel(key)}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default FilterPrototype;
